import { ITutorial, ITutorialPassos, MensagensPadrao } from "../../../Components/AdicionarAjuda";

export const IDs = {
    formularioDeFiltro: "formulario-de-filtros-banco",

    filtroDeCodigo: "campo-codigo-filtros-banco",
    filtroDeNome: "campo-descricao-filtros-banco",
    filtroDeAtivo: "campo-ativo-filtros-banco",

    botaoListar: "botao-listar-bancos",
    botaoAdicionar: "botao-adicionar-banco",
}

export const Classes = {
    botaoEditar: "botao-editar-banco",
    botaoDesativar: "botao-desativar-banco",
}

export const ConsultarBanco: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.filtros.apresentacao, target: () => document.getElementById(IDs.formularioDeFiltro)!},
        {...MensagensPadrao.filtros.codigoInterno, target: () => document.getElementById(IDs.filtroDeCodigo)!},
        {...MensagensPadrao.filtros.nome, target: () => document.getElementById(IDs.filtroDeNome)!},
        {...MensagensPadrao.filtros.ativo, target: () => document.getElementById(IDs.filtroDeAtivo)!},
        {...MensagensPadrao.filtros.botaoListar, target: () => document.getElementById(IDs.botaoListar)!},
    ]
}

export const AdicionarBanco: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.adicionar.entrada, target: () => document.getElementById(IDs.botaoAdicionar)!},
    ]
}

export const EditarBanco: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.alterar.editar, target: () => document.querySelector('.' + Classes.botaoEditar)!},
    ]
}

export const DesativarBanco: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.alterar.desativar, target: () => document.querySelector('.' + Classes.botaoDesativar)!},
    ]
}

// const tutorialMenuItems: ITutorial[] = [
//     {
//         titulo: "Como consultar centros de custos",
//         tutorial: tutorialConsultarCentro
//     },
//     {
//         titulo: "Como cadastrar um novo centro de custos",
//         tutorial: tutorialAdicionarCentro
//     },
//     {
//         titulo: "Como editar um centro de custos",
//         tutorial: tutorialEditarCentro
//     },
//     {
//         titulo: "Como desativar um centro de custos",
//         tutorial: tutorialDesativarCentro
//     }
// ]